import { COTIZADOR_CLEAR_REPORT_STATE } from './constants'

export function clearReportCotizador() {
  return async (dispatch) => {
    dispatch({
      type: COTIZADOR_CLEAR_REPORT_STATE
    })
  }
}

export function reducer(state, action) {
  if (action.type === COTIZADOR_CLEAR_REPORT_STATE) {
    return {
      ...state,
      reportFileCotizadorPending: false,
      reportFileCotizadorError: null,
      reportFileCotizadorSuccess: false
    }
  }
  else {
    return state
  }
}
